// src/lib/normalizeHomeUser.ts
import { pickNumberByPaths, pickStringByPaths } from "./path";
import { resolveBackendAssetUrl } from "./backendAsset";

export type HomeViewModel = {
  characterName: string;
  description: string;
  rankName: string;
  rankUpPoint: number;
  nextRankUpPoint: number;
  initial: string;
  online: boolean;
  imageUrl?: string; // バックエンドから取得した画像URL（http://localhostプレフィックス付き）
  iconUrl?: string; // バックエンドから取得したアイコン画像URL（http://localhostプレフィックス付き）
};

export function normalizeUserToHomeVM(u: any): HomeViewModel | null {
  const characterName = pickStringByPaths(u, [
    "currentCharacter.characterName",
    "data.currentCharacter.characterName",
    "currentCharacter.name",
    "data.currentCharacter.name",
    "character.characterName",
    "data.character.characterName",
    "characterName",
    "data.characterName",
    "userName",
    "data.userName",
    "name",
    "data.name",
  ]);
  if (!characterName) return null;

  const description =
    pickStringByPaths(u, [
      "currentCharacter.description",
      "data.currentCharacter.description",
      "currentCharacter.tagline",
      "data.currentCharacter.tagline",
      "description",
      "data.description",
      "character.description",
      "data.character.description",
    ]) ?? "";

  const rankName =
    pickStringByPaths(u, [
      "currentCharacter.rankName",
      "data.currentCharacter.rankName",
      "currentIntimacy.rankName",
      "data.currentIntimacy.rankName",
      "intimacy.rankName",
      "data.intimacy.rankName",
      "rankName",
      "data.rankName",
    ]) ?? "";

  const rankUpPoint =
    pickNumberByPaths(u, [
      "currentCharacter.rankUpPoint",
      "data.currentCharacter.rankUpPoint",
      "currentIntimacy.rankUpPoint",
      "data.currentIntimacy.rankUpPoint",
      "intimacy.rankUpPoint",
      "data.intimacy.rankUpPoint",
      "rankUpPoint",
      "data.rankUpPoint",
    ]) ?? 0;

  const nextRankUpPoint =
    pickNumberByPaths(u, [
      "currentCharacter.nextRankUpPoint",
      "data.currentCharacter.nextRankUpPoint",
      "currentIntimacy.nextRankUpPoint",
      "data.currentIntimacy.nextRankUpPoint",
      "intimacy.nextRankUpPoint",
      "data.intimacy.nextRankUpPoint",
      "nextRankUpPoint",
      "data.nextRankUpPoint",
    ]) ?? 0;

  const image =
    pickStringByPaths(u, [
      "currentCharacter.image",
      "data.currentCharacter.image",
      "image",
      "data.image",
    ]);

  const iconImage =
    pickStringByPaths(u, [
      "currentCharacter.iconImage",
      "data.currentCharacter.iconImage",
      "iconImage",
      "data.iconImage",
    ]);

  const imageUrl = resolveBackendAssetUrl(image);
  const iconUrl = resolveBackendAssetUrl(iconImage);

  return {
    characterName,
    description,
    rankName,
    rankUpPoint,
    nextRankUpPoint,
    initial: characterName.slice(0, 1).toUpperCase(),
    online: true,
    imageUrl,
    iconUrl,
  };
}
